import { CarbonIntensity } from '@/models/carbon/CarbonIntensity.js'
import { ImpactIntensity } from '@/models/carbon/ImpactIntensity.js'
import { EmissionFactor, ImpactFactor } from '@/models/carbon/Factor.js'
import FOOD_FACTORS from '@/../data/factors/carbon/foodFactors.json'
import FOOD_LCA_FACTORS from '@/../data/factors/lca/foodFactors.json'

export default class Meal {
  constructor (type, amount) {
    this.type = type
    this.amount = amount
  }

  getEmissionFactor (year = null) {
    let ef = EmissionFactor.createFromObj(FOOD_FACTORS[this.type])
    return ef.getFactor(year)
  }

  getCarbonIntensity (year = null) {
    let ef = this.getEmissionFactor(year)
    return new CarbonIntensity(
      this.amount * ef.total.total,
      this.amount * ef.total.total * ef.total.uncertainty,
      ef.group
    )
  }

  getImpact (year = null) {
    let ifactor = ImpactFactor.createFromObj(FOOD_LCA_FACTORS[this.type])
    return ImpactIntensity.compute(this.amount, ifactor)
  }

  static createFromObj (obj) {
    return new Meal(obj.type, obj.amount)
  }
}
